import { gate } from 'hub-http/gates';
import { usePropertyDefinition } from '../v2/hooks/usePropertyDefinition';
import { useObjectTypeId } from '../v2/hooks/useObjectTypeId';
import { useGetIsUngated } from '../v2/hooks/useGetIsUngated';
import { usePropertyExtensionsMetadata } from '../v2/hooks/usePropertyExtensionsMetadata';
import { getRelativeDateValueForProperty } from './utils';
import { usePropertyValue } from '../v2/hooks/usePropertyValue';
export const useShowRelativeDateValue = () => {
  const propertyDefinition = usePropertyDefinition();
  const propertyValue = usePropertyValue();
  const objectTypeId = useObjectTypeId();
  const getIsUngated = useGetIsUngated();
  const shouldFetchPropertyExtensionsMetadata = getIsUngated(gate('CRM:PropMgmt:RelativeDateWithTime')) && objectTypeId && propertyValue && propertyDefinition.type === 'date';

  // We will skip showing the relative value in case of an error.
  // Error has already been captured, no further action needed here.
  const {
    data: propertyExtensionsMetadata
  } = usePropertyExtensionsMetadata(objectTypeId, {
    skip: !shouldFetchPropertyExtensionsMetadata
  });
  if (!shouldFetchPropertyExtensionsMetadata) {
    return false;
  }
  const relativeDateValue = getRelativeDateValueForProperty(propertyExtensionsMetadata, propertyDefinition.name);
  return relativeDateValue === 'dateWithRelativeTime';
};